module.exports = __webpack_public_path__ + "img/AK0093-LU.583a3fad.jpg";